import {
	Box,
	Text,
	IconButton,
	Flex,
	Avatar,
	Center,
	Spinner,
	Tooltip,
} from '@chakra-ui/react'
import { MdOutlineOpenInNew } from 'react-icons/md'
import { useLoadActivityParticipant } from '../../../hooks/activity.hooks'
import { useEffect } from 'react'
import { useSharedContext } from './../../../context/shared.context'
import { useParticipantContext } from './../../../context/participant-tab.context'
import { participantConst } from '../../../utils/action.constant'

const CreatorsOwners = () => {
	const {
		mutate: mutateActivityParticipant,
		data: dataActivityParticipant,
		isLoading: loadingActivityParticipant,
	} = useLoadActivityParticipant()

	const {
		state: {
			activity: { activity_id },
		},
	} = useSharedContext()
	const {
		state: { participantActiveFromInfo },
		dispatch: participantDispatch,
	} = useParticipantContext()

	useEffect(() => {
		loadParticipants()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activity_id])

	const loadParticipants = () => {
		mutateActivityParticipant({ activity_id })
	}

	const isCreatorOwner = asset => {
		const { activity_creator_asset_id, asset_id, asset_flag_is_owner } = asset
		if (asset_id === activity_creator_asset_id) return 'Creator'
		if (asset_flag_is_owner) return 'Owner'
		return 'Participant'
	}

	const renderCreatorOwnerList = () => {
		const creatorOwnerList = []
		dataActivityParticipant?.list.forEach(participant => {
			if (isCreatorOwner(participant) !== 'Participant')
				creatorOwnerList.push(participant)
		})

		if (creatorOwnerList.length === 0)
			return <Text>No creators and owners present</Text>

		return creatorOwnerList.map(participant => {
			return (
				<Box key={participant.asset_id} textAlign='center' p='1rem'>
					<Avatar
						name={participant.operating_asset_first_name?.trim()}
						color='white'
						bg='brand.700'
						size='md'
					/>
					<Text>{participant.operating_asset_first_name?.trim()}</Text>
					<Text color='gray.200'>{isCreatorOwner(participant)}</Text>
				</Box>
			)
		})
	}
	if (loadingActivityParticipant)
		return (
			<Center p={5}>
				<Spinner size='lg' color='brand.700' />
			</Center>
		)

	return (
		<Box bg='white' w='100%' p='1rem'>
			<Flex alignItems='center'>
				<Text color='brand.700' fontSize='1rem' fontWeight='500' as='b'>
					Creators, Owners
				</Text>
				<Tooltip hasArrow label='Open Participants tab' placement='top' bg='green.600'>
				<IconButton
					aria-label='open'
					icon={<MdOutlineOpenInNew />}
					ml='1rem'
					variant='requestSummaryIconButton'
					onClick={() => {
						participantDispatch({
							type: participantConst.SET_PARTICIPANT_ACTIVE,
						})
					}}
				/>
				</Tooltip>
			</Flex>
			<Flex overflowX='scroll'>{renderCreatorOwnerList()}</Flex>
		</Box>
	)
}

export { CreatorsOwners }
